import React, { useState } from 'react';
import AuthLayout from './AuthLayout';
import { supabase } from '../../lib/supabase';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const ForgotPassword = ({ isDarkMode, setIsDarkMode }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleReset = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/reset-password`,
        });

        if (resetError) {
            setError(resetError.message);
        } else {
            setSuccess(true);
        }
        setLoading(false);
    };

    return (
        <AuthLayout
            title="Reset Password"
            subtitle="We'll send you a recovery link"
            isDarkMode={isDarkMode}
            setIsDarkMode={setIsDarkMode}
        >
            {success ? (
                <div className="text-center">
                    <div className={`w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 ${isDarkMode ? 'bg-green-500/10' : 'bg-green-50'}`}>
                        <CheckCircle className="text-green-500 w-10 h-10" />
                    </div>
                    <p className={`font-black uppercase tracking-tight mb-8 ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
                        Check your email! We've sent a link to <span className="text-blue-500">{email}</span>.
                    </p>
                    <Link to="/login" className="text-blue-500 font-black uppercase tracking-widest text-xs hover:underline">
                        Back to Sign In
                    </Link>
                </div>
            ) : (
                <form onSubmit={handleReset} className="space-y-6">
                    <div>
                        <label className={`block text-[10px] font-black uppercase tracking-widest mb-1 shadow-sm ${isDarkMode ? 'text-gray-400' : 'text-slate-500'}`}>
                            Email Address
                        </label>
                        <div className="relative">
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={`w-full pl-12 pr-4 py-4 rounded-2xl border transition-all focus:ring-2 outline-none font-bold text-sm ${isDarkMode
                                    ? 'bg-cosmic-800 border-white/10 text-white focus:ring-mystic-teal/50 focus:border-mystic-teal/50'
                                    : 'bg-slate-50 border-slate-200 text-slate-900 focus:ring-blue-500/20'
                                    }`}
                                placeholder="name@example.com"
                            />
                            <Mail className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 ${isDarkMode ? 'text-gray-600' : 'text-slate-400'}`} />
                        </div>
                    </div>

                    {error && (
                        <div className="bg-red-500/10 border border-red-500/20 text-red-500 text-xs font-black p-4 rounded-xl text-center uppercase tracking-tighter">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-gradient-to-r from-blue-600 to-mystic-purple hover:scale-[1.02] active:scale-[0.98] text-white font-black py-5 rounded-[24px] shadow-lg shadow-mystic-purple/20 flex items-center justify-center space-x-3 transition-all disabled:opacity-50"
                    >
                        <span>{loading ? 'Sending...' : 'Send Reset Link'}</span>
                        <ArrowRight className="w-5 h-5" />
                    </button>

                    <div className="text-center">
                        <Link to="/login" className={`text-xs font-black uppercase tracking-widest hover:underline ${isDarkMode ? 'text-gray-500' : 'text-slate-400'}`}>
                            Remembered? Sign In
                        </Link>
                    </div>
                </form>
            )}
        </AuthLayout>
    );
};

export default ForgotPassword;
